export default "__VITE_ASSET__CQxx5pQ9__"